{
    "forgottenPassword": {
        "resetPassword": "Passwort zurücksetzen",
        "enterEmailAddressAssociatedWithYourAccount": "Geben Sie die mit Ihrem Konto verknüpfte E-Mail-Adresse ein",
        "emailAddress": {
            "label": "Nutzerkennung *",
            "placeholder": "Nutzerkennung"
        },
        "enterValidEmail": "Bitte geben Sie eine gültige Email-Adresse ein.",
        "passwordResetEmailSent": "Ein neues Passwort wird an die bei der RINGFOTO-Zentrale gespeicherte Standard-E-Mail Adresse gesendet. Bitte folgen Sie den Anweisungen in der E-Mail.",
        "passwordResetSuccess": "Sie können sich nun mit Ihrem neuen Passwort anmelden."
    },
    "register": {
        "newPassword": "Neues Passwort",
        "resetPassword": "Neues Passwort Speichern",
        "passwordMinRequirements": "Passwort muss min. 6 Zeichen lang sein, mit einem Großbuchstaben, einer Zahl, einem Symbol.",
        "password": {
            "placeholder": "Neues Passwort"
        },
        "confirmPassword": {
            "placeholder": "Neues Passwort bestätigen"
        }
    },
    "updateEmailForm": {
        "newEmailAddress": {
          "label": "Neue E-Mail Adresse",
          "placeholder": "Neue E-Mail Adresse eingeben"
        },
        "confirmNewEmailAddress": {
          "label": "Neue E-Mail Adresse bestätigen",
          "placeholder": "Neue E-Mail Adresse eingeben"
        },
        "enterValidEmail": "Please enter a valid email.",
        "bothEmailMustMatch": "Both emails must match",
        "password": {
          "label": "Passwort",
          "placeholder": "Passwort eingeben"
        },
        "pleaseInputPassword": "Please input password",
        "emailUpdateSuccess": "Erfolg. Bitte melden Sie sich mit an {{ newUid }} "
      }
}
